import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=608a67ba&"
import script from "./basic.vue?vue&type=script&lang=js&"
export * from "./basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('608a67ba')) {
      api.createRecord('608a67ba', component.options)
    } else {
      api.reload('608a67ba', component.options)
    }
    module.hot.accept("./basic.vue?vue&type=template&id=608a67ba&", function () {
      api.rerender('608a67ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/tax-payer/basic.vue"
export default component.exports